function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.58478 1.55029L9.75814 2.72365C9.98642 2.95193 10.1675 3.22293 10.291 3.52119C10.4146 3.81945 10.4782 4.13912 10.4782 4.46195C10.4782 4.78479 10.4146 5.10446 10.291 5.40272C10.1675 5.70097 9.98642 5.97198 9.75814 6.20026L9.14973 6.80866L7.97638 5.63531C7.7481 5.40703 7.56702 5.13603 7.44348 4.83777C7.31993 4.53951 7.25635 4.21984 7.25635 3.897C7.25635 3.57417 7.31993 3.2545 7.44348 2.95624C7.56702 2.65798 7.7481 2.38698 7.97638 2.1587L8.58478 1.55029Z",
  stroke: "currentColor",
  strokeWidth: 1.25,
  strokeMiterlimit: 10
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M10.3443 7.99691L9.1709 6.82355L9.75758 6.23688C9.98585 6.0086 10.2569 5.82752 10.5551 5.70398C10.8534 5.58043 11.173 5.51685 11.4959 5.51685C11.8187 5.51685 12.1384 5.58043 12.4366 5.70398C12.7349 5.82752 13.0059 6.0086 13.2342 6.23688L14.4075 7.41023L13.8426 7.97518C13.6143 8.20346 13.3433 8.38454 13.045 8.50808C12.7468 8.63162 12.4271 8.69521 12.1043 8.69521C11.7815 8.69521 11.4618 8.63162 11.1635 8.50808C10.8653 8.38454 10.5943 8.20346 10.366 7.97518L10.3443 7.99691Z",
  stroke: "currentColor",
  strokeWidth: 1.25,
  strokeMiterlimit: 10
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M6.23981 3.89368L7.41317 5.06703C7.64145 5.29531 7.82252 5.56631 7.94607 5.86457C8.06961 6.16283 8.1332 6.4825 8.1332 6.80534C8.1332 7.12817 8.06961 7.44784 7.94607 7.7461C7.82252 8.04436 7.64145 8.31536 7.41317 8.54364L6.82649 9.13032L5.65313 7.95696C5.42486 7.72869 5.24378 7.45768 5.12023 7.15942C4.99669 6.86116 4.93311 6.54149 4.93311 6.21866C4.93311 5.89583 4.99669 5.57615 5.12023 5.27789C5.24378 4.97964 5.42486 4.70863 5.65313 4.48035L6.23981 3.89368Z",
  stroke: "currentColor",
  strokeWidth: 1.25,
  strokeMiterlimit: 10
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M8.00441 10.3445L6.83105 9.17116L7.40035 8.60187C7.86138 8.14084 8.48666 7.88184 9.13865 7.88184C9.79064 7.88184 10.4159 8.14084 10.877 8.60187L12.0764 9.80129L11.5288 10.3489C11.2994 10.5841 11.0252 10.771 10.7224 10.8984C10.4196 11.0259 10.0943 11.0914 9.7657 11.091C9.43714 11.0905 9.11199 11.0243 8.80947 10.8961C8.50696 10.7679 8.23321 10.5803 8.00441 10.3445Z",
  stroke: "currentColor",
  strokeWidth: 1.25,
  strokeMiterlimit: 10
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M3.89679 6.24133L5.07015 7.41469C5.29843 7.64297 5.47951 7.91397 5.60305 8.21223C5.72659 8.51049 5.79018 8.83016 5.79018 9.15299C5.79018 9.47583 5.72659 9.7955 5.60305 10.0938C5.47951 10.392 5.29843 10.663 5.07015 10.8913L4.48347 11.478L3.33185 10.3263C3.10357 10.0981 2.92249 9.82707 2.79895 9.52881C2.6754 9.23055 2.61182 8.91088 2.61182 8.58804C2.61182 8.26521 2.6754 7.94554 2.79895 7.64728C2.92249 7.34902 3.10357 7.07802 3.33185 6.84974L3.91852 6.26306L3.89679 6.24133Z",
  stroke: "currentColor",
  strokeWidth: 1.25,
  strokeMiterlimit: 10
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M5.65382 12.6966L4.48047 11.5233L5.06715 10.9366C5.52817 10.4756 6.15346 10.2166 6.80545 10.2166C7.45744 10.2166 8.08273 10.4756 8.54375 10.9366L9.73884 12.1317L9.17389 12.6966C8.94487 12.9315 8.67116 13.1181 8.36889 13.2456C8.06662 13.373 7.74189 13.4386 7.41386 13.4386C7.08582 13.4386 6.7611 13.373 6.45883 13.2456C6.15655 13.1181 5.88285 12.9315 5.65382 12.6966Z",
  stroke: "currentColor",
  strokeWidth: 1.25,
  strokeMiterlimit: 10
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M14.4532 1.54688V2.57938C14.4532 2.90221 14.3896 3.22188 14.2661 3.52014C14.1425 3.8184 13.9615 4.0894 13.7332 4.31768C13.5049 4.54596 13.2339 4.72704 12.9356 4.85058C12.6374 4.97412 12.3177 5.03771 11.9949 5.03771H10.9316V4.03594C10.9316 3.38395 11.1906 2.75866 11.6517 2.29763C12.1127 1.83661 12.738 1.5776 13.39 1.5776H14.4532V1.54688Z",
  stroke: "currentColor",
  strokeWidth: 1.25,
  strokeMiterlimit: 10
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M1.54688 14.4532L4.47844 11.5216",
  stroke: "currentColor",
  strokeWidth: 1.25,
  strokeMiterlimit: 10
});

var SvgDiet = function SvgDiet(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDiet, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/diet.9633cc48.svg";
export { ForwardRef as ReactComponent };